import { mapGetters } from 'vuex';
import Permission from '@/classes/permission';

const authCheck = {
	computed: {
		...mapGetters('principal', ['user']),
		userPermissions() {
			const perms = [];

			if (this.user && this.user.EmployeeRolePermission) {
				this.user.EmployeeRolePermission.forEach(p => {
					//permissions are in format permissionId.permission, ex: 2.Create
					const permParts = p.split('.');

					if (permParts.length === 2) {
						perms.push({
							permissionId: parseInt(permParts[0]),
							permission: permParts[1].toLowerCase()
						});
					}
				});
			}

			return perms;
		}
	},
	methods: {
		hasPermission(permissionId, permission) {
			const requiredPermission = new Permission(permissionId, permission);
			const matchedPerm = this.userPermissions.filter(up => {
				return requiredPermission.checkPermission(up);
			});

			return matchedPerm.length > 0;
		}
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			let authorized = true;
			let requiredPermissions = [];
			let anyPermission = [];
			let userPermissions = vm.userPermissions;
			let anyPermissionIndex = -1;

			if (vm.requiredPermissions != undefined) {
				if (Array.isArray(vm.requiredPermissions)) {
					requiredPermissions = vm.requiredPermissions;
				} else if (typeof vm.requiredPermissions == 'function') {
					requiredPermissions = vm.requiredPermissions();
				} else {
					requiredPermissions = [vm.requiredPermissions];
				}

				authorized = requiredPermissions.every(function(reqPerm) {
					const matchedPerm = userPermissions.filter(up => {
						return reqPerm.checkPermission(up);
					});
					return matchedPerm.length > 0;
				});
			}

			if (vm.anyPermission != undefined) {
				if (Array.isArray(vm.anyPermission)) {
					anyPermission = vm.anyPermission;
				} else if (typeof vm.anyPermission == 'function') {
					anyPermission = vm.anyPermission();
				} else {
					anyPermission = [vm.anyPermission];
				}

				anyPermissionIndex = anyPermission.findIndex(function(reqPerm) {
					const matchedPerm = userPermissions.filter(up => {
						return reqPerm.checkPermission(up);
					});
					return matchedPerm.length > 0;
				});

				authorized = authorized && anyPermissionIndex >= 0;
			}

			if (!authorized) {
				vm.$router.push({ name: 'access-denied' });
			}

			return authorized;
		});
	}
};

export default authCheck;
